import { PropertyManifestEntry } from '@features/home-manifest/types';
import { ManifestDevice } from '@features/plan-manifest/types';
import AllPaired from './AllPaired';
import NotAllPaired from './NotAllPaired';
import { Category } from '@lib/labels';
import { Stack } from '@mui/material';
import React from 'react';

interface PairingConfirmationProps {
  manifestEntries: PropertyManifestEntry[];
}

const PairingConfirmation: React.FC<PairingConfirmationProps> = ({ manifestEntries }) => (
  <Stack direction="row" justifyContent="center" sx={{ width: '100%', height: '100%' }}>
    {manifestEntries.every(
      (e) =>
        e.provisioned ||
        (e.device as ManifestDevice)?.sensors?.some(
          (s) => s.sensor_category === Category.system
        )
    ) ? (
      <AllPaired />
    ) : (
      <NotAllPaired />
    )}
  </Stack>
);

export default PairingConfirmation; 